module.exports = __webpack_public_path__ + "media/react/assets/imgs/noinfo-00e4febc18e70b2ea6c3f8b855fbe7ad.png";